var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-radio"},[_c('div',{staticClass:"row"},[_c('div',{class:_vm.form.class},[_c('Radio',{attrs:{"classes":_vm.form.classes,"name":_vm.form.model,"action":_vm.form.name,"placeholder":_vm.form.placeholder,"options":_vm.form.options},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }